export default function SwitchIcon() {
    return (<svg id="_20X20_photo_Back" data-name="20X20 photo Back" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
        <g id="Mask_Group_398" data-name="Mask Group 398">
            <path id="keyboard" d="M20,3H4A2,2,0,0,0,2.01,5L2,15a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3ZM11,6h2V8H11Zm0,3h2v2H11ZM8,6h2V8H8ZM8,9h2v2H8ZM7,11H5V9H7ZM7,8H5V6H7Zm9,7H8V13h8Zm0-4H14V9h2Zm0-3H14V6h2Zm3,3H17V9h2Zm0-3H17V6h2Z" transform="translate(-2)" fill="#f7f7f7" />
        </g>
    </svg>
    )
}